
export enum StatusCode {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  ALREADY_VOTED = 'ALREADY_VOTED',
}
